module.exports = __webpack_public_path__ + "static/media/YF10_0.cbeeed75.jpg";